/*
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-03-05 14:13:48
 * @Description: deal with query display cache
 */
import qs from 'qs'
import { isEmpty, setTimeWithUTC } from '@/utils'

export function getTaskQueryDisplayStr (params, timeZone) {
  const query = { ...params }
  query.topic = query.topicName
  delete query.topicName
  delete query.topicId
  delete query.statusSet
  if (query.from && query.to) {
    query.from = setTimeWithUTC(query.from, timeZone)
    query.to = setTimeWithUTC(query.to, timeZone)
  }
  Object.keys(query).forEach(item => {
    // console.log(item, typeof query[item], query[item], query[item]?.length)
    if (isEmpty(query[item])) {
      delete query[item]
    }
  })
  if (!qs.stringify(query) || qs.stringify(query) === '{}') return null
  return query
}
